import { cachedGet } from "../cache";
import { API_ENDPOINTS } from "../endpoints";
import type { ApiResponse, Currency } from "../interface";

export const resourceService = {
  async getCountries() {
    return cachedGet<ApiResponse<string[]>>(
      API_ENDPOINTS.countries
    );

  },

  async getLanguages() {
    return cachedGet<ApiResponse<string[]>>(
      API_ENDPOINTS.languages
    );

  },

  async getCurrencies() {
    return cachedGet<ApiResponse<Currency[]>>(
      API_ENDPOINTS.currencies
    );

  },
};
